import React, { useState, useEffect, useContext } from 'react'
import Wrapper from '../../../../components/common/Wrapper/Wrapper'
import service from '../../../../api/services'
import constant from '../../../../constants/constant'
import { Default_Page_Limit } from "../../../../constants/defaultValues"
import organisms from '../../../../components/organisms'
import { HeaderHeading } from '../../../../Context'
import { useToasts } from 'react-toast-notifications'


const { OrderReceived } = organisms

const Index = () => {
  const { addToast } = useToasts();
  const [initialLoading, setInitialLoading] = useState(false)
  const [orderReceivedList, setOrderReceivedList] = useState<[] | undefined>();
  const [limitPerPage, setLimitPerPage] = useState<number>(Default_Page_Limit);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [search, setSearch] = useState<string | undefined>();
  const { setHeader }: any = useContext(HeaderHeading);
  const [createdTo, setCreatedTo] = useState()
  const [createdFrom, setCreatedFrom] = useState()
  const [isContactLensProduct,setIsContactLensProduct]=useState<boolean>(false)


  const viewCancelledList = async () => {
    try {
      const response = await service?.procurementService?.OrderReceivedList({
        "page": currentPage,
        "search": search,
        "limit": limitPerPage,
        "status": constant.PROCUREMENT_ITEM_STATUS.DELIVERED,
        "created_from": createdFrom,
        "created_to": createdTo,
        "is_contact_lens":isContactLensProduct
      })
      if (response.status === 200) {
        setOrderReceivedList(response?.data)
      }
    } catch (error: any) {
      console.error(error)
      addToast(error.response?.data?.message, {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 3000,
      });
  }
  }

  useEffect(() => {
    setHeader("Procurement - Order Received")
    if (initialLoading) {
      viewCancelledList()
    } else {
      setInitialLoading(true)
    }
  }, [search, currentPage])

  useEffect(() => {
    setCurrentPage(1)
    if (currentPage == 1) {
      viewCancelledList()
    }
  }, [limitPerPage,isContactLensProduct])

  useEffect(() => {
    if (createdTo && createdFrom) {
      viewCancelledList()
    }
  }, [createdFrom, createdTo])
  return (
    <Wrapper>
      <OrderReceived
        orderReceivedList={orderReceivedList}
        setSearch={setSearch}
        limit={limitPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setLimitPerPage={setLimitPerPage}
        setCreatedTo={setCreatedTo}
        setCreatedFrom={setCreatedFrom}
        isContactLensProduct={isContactLensProduct}
        setIsContactLensProduct={(value:boolean)=>setIsContactLensProduct(value)}
      />
    </Wrapper>
  )
}

export default Index